export default __webpack_public_path__ + "static/media/a4m.829ec1e2.png";